module.exports = __webpack_public_path__ + "img/reptiles.fa352b2f.png";